const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Cookie Policy</h1>
        <p className="text-gray-600 mb-8">Last updated: November 2025</p>

        <div className="prose prose-lg max-w-none space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your computer or mobile device when you visit our website. They help us remember information about you and your preferences, improve your browsing experience, and analyze how you use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Types of Cookies We Use</h2>
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Performance Cookies</h3>
            <p>
              These cookies collect information about how you use our website, such as which pages you visit and whether you experience any errors. This information helps us improve the performance of our site.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Functional Cookies</h3>
            <p>
              These cookies enable our website to remember your preferences and to provide personalized features and functionality.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-3">Targeting/Advertising Cookies</h3>
            <p>
              These cookies are used to track your browsing habits and to show you targeted advertisements based on your interests.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. How We Use Cookies</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To remember your login information and preferences</li>
              <li>To understand how you use our website</li>
              <li>To improve our website and services</li>
              <li>To provide you with relevant content and advertisements</li>
              <li>To analyze website traffic and user behavior</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Third-Party Cookies</h2>
            <p>
              We may allow third-party service providers to place cookies on your browser for analytics, advertising, and other purposes. These third parties have their own privacy policies, and we encourage you to review them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Your Cookie Choices</h2>
            <p>
              You can control and manage cookies in various ways:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Most web browsers allow you to refuse cookies or alert you when a cookie is being sent</li>
              <li>You can delete cookies from your browser at any time</li>
              <li>You can change your browser settings to disable cookies</li>
            </ul>
            <p className="mt-4">
              Please note that disabling cookies may affect the functionality of our website and your user experience.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this policy regularly to stay informed about how we use cookies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Contact Us</h2>
            <p>
              If you have any questions about our use of cookies, please contact us at:
            </p>
            <p>
              <strong>Acuity Practice</strong><br />
              Trust Tech Digital<br />
              <a href="mailto:privacy@acuitypractice.com" className="text-primary-500 hover:text-primary-600">privacy@acuitypractice.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicyPage
